import React, {useEffect } from "react";
import Head from "../../../layout/head/Head";
import { useQuery } from "@tanstack/react-query";
import { loginAxios } from '../../../config/axios.config';
import { toast, ToastContainer } from "react-toastify";
import HeaderMain from "../../../layout/header/Header";
import FormInitAdd from './FormInitAdd';
import DesignerDetails from './DesignerDetails';

const StepsDesignerForm = () => {
    const [message, setMessage] = React.useState(false);
    const chooseMessage = (message) => {
        setMessage(message);
    };

    useEffect(() => {
        toast.info("Please complete below registration form", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            progress: false,
        });
    }, []);



    const getProfileDetails = async () => {
        try {
            const { data } = await loginAxios.get(`designers/user-details`, {
                headers: {
                    'x-auth-token': localStorage.getItem('accessToken')
                }
            });
            return data;
        } catch (error) {
            return Promise.reject(error);
        }
    };

    const { isFetching, isLoading, error, isSuccess, isError, data, refetch: fetchProFileDetails } = useQuery(['getProfileDetails'], getProfileDetails, {
        refetchOnMount: false,
        refetchOnWindowFocus: false,        
    });


    return (
        <React.Fragment>
            <HeaderMain />
            <Head title="Registration Form" />
            
            {data?.data?.is_approved == 0 && <FormInitAdd chooseMessage={chooseMessage} />}
            {data?.data?.is_approved == 1 && <DesignerDetails />}

            <ToastContainer />
        </React.Fragment>
    );
};

export default StepsDesignerForm;